import './YoutubeVideo.css';

const YoutubeVideo = ({ videoId }) => {
    return (
        <div className="video-container">
            <div className="video-wrapper">
                <iframe
                src={`https://www.youtube.com/embed/${videoId}`}
                title="YouTube video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                ></iframe>
            </div>
        </div>
    );
};

export default YoutubeVideo;
